import { ItemsState } from './../../common/services/items.service';
import { HappeningBeforePipe } from './../../common/pipes/happening-before.pipe';
import { Store } from '@ngrx/store'; ``
import { Injectable, Pipe, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Broker, BrokerRequest } from '@c4/core';

import { SharedProgrammingService, CommonProgrammingContext } from './../../common/services/shared-programming.service';
import { DeviceCategoryService } from './../../common/services/device-category.service';
import { ProgrammingUtilsService } from '../../common/services/utils.service';
import { letsTalkReducer } from '../../common/services/lets-talk.service';
import { ItemsService } from '../../common/services/items.service';

// const SUPPORTED_ACTIONS: Supported[] = require('../assets/data/quickstart-actions.json');
// const SUPPORTED_TRIGGERS: Supported[] = require('../assets/data/quickstart-triggers.json');

export interface QuickstartsContext {
  ready: boolean;
  saved: boolean;
  adding: boolean;
  errors?: Array<any>;
  error: boolean;
  searchText: string;
  supportedTriggers: Array<Supported>;
  supportedActions: Array<Supported>;
  pageTitle?: string;
}

interface Supported {
  label: string;
  icon: string;
  route: string;
  requires: {
    [key: string]: {
      values: string[];
      match: string
    }
  };
  enabled: boolean
}

const INITIAL_STATE: QuickstartsContext = {
  ready: false,
  error: false,
  saved: false,
  adding: false,
  searchText: '',
  supportedTriggers: [],
  supportedActions: [],
};

const STORE_NAME: string = 'PROGRAMMING:QUICKSTARTS:';
const SET_SIMPLE: string = STORE_NAME + 'SET_SIMPLE';
const SET_PACKAGED: string = STORE_NAME + 'SET_PACKAGED';
const SET_CATEGORY: string = STORE_NAME + 'SET_CATEGORY';
const SET_QUICKSTART_TRIGGERS: string = STORE_NAME + 'SET_QUICKSTART_TYPES';
const SET_QUICKSTART_ACTIONS: string = STORE_NAME + 'SET_QUICKSTART_ACTIONS';
const SET_READY: string = STORE_NAME + 'SET_READY';
const SET_ERROR: string = STORE_NAME + 'SET_ERROR';
const SET_SAVED: string = STORE_NAME + 'SET_SAVED';
const SET_ADDING: string = STORE_NAME + 'SET_ADDING';
const CLEAR_ERROR: string = STORE_NAME + 'CLEAR_ERROR';
const CLEAR_ACTION: string = STORE_NAME + 'CLEAR_ACTION';
const CLEAR_ALL: string = STORE_NAME + 'CLEAR_ALL';

export function quickstartsReducer(state: QuickstartsContext = INITIAL_STATE, { type, payload }) {
  // console.log('quickstartReducer received: ', type, payload);
  switch (type) {
    case SET_QUICKSTART_TRIGGERS: return Object.assign({}, state, { supportedTriggers: payload });
    case SET_QUICKSTART_ACTIONS: return Object.assign({}, state, { supportedActions: payload });


    case SET_READY: return Object.assign({}, state, { ready: payload });
    case SET_ERROR: return Object.assign({}, state, { error: true, errors: payload });
    case SET_SAVED: return Object.assign({}, state, { saved: payload });
    case SET_ADDING: return Object.assign({}, state, { adding: payload });

    case CLEAR_ERROR: return Object.assign({}, state, { error: false, errors: undefined });
    case CLEAR_ALL: return Object.assign({}, INITIAL_STATE);

    default: return state;
  }
};

@Injectable()
export class QuickstartProgrammingService {

  constructor(
    private broker: Broker,
    private store: Store<{
      sharedProgramming: CommonProgrammingContext,
      programmingItems: ItemsState
    }>,
    private utils: ProgrammingUtilsService,
    private items: ItemsService,
    private shared: SharedProgrammingService
  ) {
    this.items.itemsList.filter(i => !!i).distinctUntilChanged().subscribe(items => {
      let supportableActions = require('../assets/data/quickstart-actions.json');
      let supportedActions = this.filterUnsupported(supportableActions);
      this.store.dispatch({ type: SET_QUICKSTART_ACTIONS, payload: supportedActions });

      // TODO is this even used anymore?
      // let supportableTriggers = require('../assets/data/quickstart-triggers.json');
      // let supportedTriggers = this.filterUnsupported(supportableActions);
      // this.store.dispatch({type: SET_QUICKSTART_ACTIONS, payload: supportedTriggers});
    });
  }

  private filterUnsupported(supportable: Array<Supported>): Array<Supported> {
    let supported = [];

    let categories = this.utils.getValue(this.store, s => s.sharedProgramming.categories);
    let agents = this.utils.getValue(this.store, s => s.sharedProgramming.agents);
    let itemMap = this.utils.getValue(this.store, s => s.programmingItems.itemsMap);

    supportable.forEach(type => {
      if (!type.requires) {
        supported.push(type);
      } else {
        // console.log('checking quickstart type against project', type);
        if (this.matchesRequiredCategories(type.requires, categories) &&
          this.matchesRequiredAgents(type.requires, agents) &&
          this.matchesRequiredCapabilities(type.requires, itemMap)) {
          supported.push(type);
        }
      }
    });

    return supported;
  }

  private matchesRequiredCategories(required: any, categories: Array<string>): boolean {
    let matches = false;

    if (required.categories && categories) {
      for (let i = 0; i < required.categories.values.length; i++) {
        let val = required.categories.values[i];
        if (required.categories.match === 'all' && categories.indexOf(val) === -1) {
          break;
        } else if (required.categories.match === 'any' && categories.indexOf(val) >= 0) {
          matches = true;
          break;
        }
      }
    } else {
      matches = true;
    }

    return matches;
  }

  private matchesRequiredAgents(required: any, agents: Array<any>): boolean {
    let matches = false;

    if (required.agents && agents) {
      // console.log('checking for agent match', required, agents);
      let found = agents.filter(agent => {
        let name = agent.toLowerCase();
        if (required.agents.values) {
          return (required.agents.values.indexOf(name) >= 0);
        }
      });

      matches = (found.length > 0);
    } else {
      matches = true;
    }

    return matches;
  }

  private matchesRequiredCapabilities(required: any, itemMap: any): boolean {
    let matches = false;

    if (required.capabilities) {

    } else {
      matches = true;
    }

    return matches;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/services/quickstart-programming.service.ts